/**
 * Dependencies.
 */
import { BaseModel } from '@prz-dp/services';

/**
 * Export `DriverModel`.
 */
export default class DriverModel extends BaseModel {
  /**
   * Properties.
   */
  id?: number;

  name: string;

  photo: {
    encodedFileContent: string;
    mediaType: string;
  };

  photoLink?: string;

  /**
   * Constructor.
   */
  constructor(data: Partial<DriverModel>) {
    super(data);
  }
}
